
















































import move from 'array-move'
import Vue from 'vue'
import { Component, Emit, Prop, Ref } from 'vue-property-decorator'
import draggable from 'vuedraggable'

import { MediaFileData } from "../../logic/MediaFileData";
import MediaManager from '../../logic/MediaManager'
import { MediaFileStatus } from '../../types'
import UploadArea from '../UploadArea.vue'
import MediaItem from './MediaItem.vue'

@Component({
  components: {
    UploadArea,
    MediaItem,
    draggable
  },
  data() {
    return {
      MediaFileStatus,
    }
  }
})
export default class MediaList extends Vue {
  @Ref('media-list') listContainer!: Vue

  @Prop() mediaManager!: MediaManager

  @Prop({ type: Boolean, default: false }) disabled!: boolean

  @Prop() noAvailableFileTypes!: boolean

  @Prop({ type: Boolean, required: false, default: false }) draggable!: boolean

  @Emit()
  openModal(): this {
    return this
  }

  get showArea(): boolean {
    return this.mediaManager.canUploadMoreFiles()
  }

  onMove(index: number, direction: any): void {
    const to = direction === 'Forward' ? index + 1 : index - 1

    this.mediaManager.attachments = move(this.mediaManager.attachments, index, to)
    this.mediaManager.updateModel()
  }

  removeAttachment(a: MediaFileData) {
    this.mediaManager.removeAttachment(a)
  }

  onScrollHandler(e: WheelEvent): void {
    this.listContainer.$el.scroll({ behavior: 'smooth', left: this.listContainer.$el.scrollLeft + e.deltaY })

    e.stopPropagation()
    e.preventDefault()
  }
}
